<template>
  <div class="py-6">
    <h3 class="text-center text-3xl font-semibold text-secondary mb-6">
      {{$t('homepage.top_categories.title_white')}} <span class="text-accent font-bold">{{$t('homepage.top_categories.title_red')}}</span>
    </h3>
    <div class="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-6">
      <TopCategoryItem
        v-for="category in categories"
        :key="category.id"
        :category="category"
      />
    </div>
  </div>
</template>

<script>
import TopCategoryItem from "@/components/UI/Category/TopCategoryItem";
export default {
  name: "TopCategories",
  components: {
    TopCategoryItem,
  },
  props: {
    categories: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style>
</style>